import jquery from 'jquery';

import _pick from 'lodash/pick';
import _isEqual from 'lodash/isEqual';
import _size from 'lodash/size';
import _compact from 'lodash/compact';
import _castArray from 'lodash/castArray';

var Config = function() {
  var self = this;

  self.config = self._getConfig();
  self.page_config = self._getMetaConfig('page-config');
  self.theme_settings = self._getMetaConfig('theme-settings');
};

/**
 * @private
 *
 * @description
 * Тянем настройки магаза из меты
 *
 * @return {Object} - настройки
 */
Config.prototype._getConfig = function() {
  var self = this;
  var _clientGroup = self._getSavedClientGroup();
  var _config = jquery('[name="shop-config"]').data('config') || {};

  if (!_isEqual(_clientGroup, _config.client_group)) {
    _config.clear_cache = true;
  }
  self._saveClientGroup(_config.client_group);

  return _config;
};

/**
 * @private
 *
 * @description
 * Тянем настройки магаза из меты
 *
 * @return {Object} - настройки
 */
Config.prototype._getMetaConfig = function(attrName) {
  var self = this;
  var _clientGroup = self._getSavedClientGroup();
  var _config = jquery('[name="' + attrName + '"]').data('config') || {};

  return _config;
};

/**
 * @private
 * Получение конфига
 *
 * @param {String|Array|null} _fields - список полей, которые надо вернуть.
 *
 * @return {Object}
 * возвращает список полей и их значений. если указывалось только одно поле - возвращается только его значение.
 */
Config.prototype.get = function(_fields) {
  var self = this;
  var _fieldsCount = [];
  var result = {};

  _fieldsCount = _size(_compact(_castArray(_fields)));

  if (_fieldsCount) {
    result = _pick(self.config, _fields);
  } else {
    result = self.config;
  }

  return result;
};

/**
 * @public
 * Получение id продукта
 * @return {String}
 * возвращает id продукта.
 */
Config.prototype.getProducId = function() {
  var self = this;
  var result = null;

  if (~document.location.pathname.indexOf('/product')) {
    result = jquery('[name="product-id"]').attr('content');
  } else {
    console.warn('Тащите продукт с карточки товара!');
  }

  return result;
};

/**
 * @public
 */
Config.prototype.setParam = function(name, value) {
  var self = this;
  if (!name) {
    return;
  }

  return self.config[name] = value;
};

Config.prototype.getArticleId = function() {
  var self = this;
  var result = null;

  if (~document.location.pathname.indexOf('/blog')) {
    result = jquery('[name="page-config"]').attr('data-config').replace(/\D+/g, '');
  } else {
    console.warn('Тащите id со страницы статьи!');
  }

  return result;
};

Config.prototype.getProductId = function() {
  var self = this;

  return self.getProducId();
};

Config.prototype._getSavedClientGroup = function() {
  var _savedClientGroup = null;

  try {
    _savedClientGroup = JSON.parse(localStorage.getItem('client_group'));
  } catch (err) {
    console.warn('Hello, Safari!!!');
  }

  return _savedClientGroup;
};

Config.prototype._saveClientGroup = function(clientGroup) {
  try {
    localStorage.setItem('client_group', JSON.stringify(clientGroup));
  } catch (err) {
    console.warn('Hello, Safari');
  }

  return;
};

export default Config;
